import React, {Component, PropTypes} from 'react'
import style from './CardGroup.less'

class CardGroup extends Component {
    static propTypes = {
    }

    _enhance(children) {
        return React.Children.map(children, (child) => {
            if (child && child.props) {
                return React.cloneElement(child, {
                    grouped: true
                })
            }
            return child
        })
    }

    render() {
        const {children} = this.props

        return (
            <div className={style.default}>
                {this._enhance(children)}
            </div>
        )
    }
}

export default CardGroup


// WEBPACK FOOTER //
// ./lib/core/components/CardGroup.js